var encodeCustomizable = function encodeCustomizable(model, _ref) {
  var seats = _ref.seats,
    functionality = _ref.functionality,
    armrests = _ref.armrests,
    feet = _ref.feet,
    coatings = _ref.coatings,
    comfort = _ref.comfort;
  return [model, seats.code, functionality.code, armrests.code, feet.code, coatings.code, comfort.code].join('');
};
export default encodeCustomizable;